import { useQuery } from "@tanstack/react-query";
import scenarioRepository from "@/repository/scenarioRepository";
import { OwnScenario } from "@/model";


const getData = async () => {
    const response = await scenarioRepository.findAll();
    return response.data;
};

export const useScenariosAll = () => {
    return useQuery<OwnScenario[]>({
        queryKey: ['scenarios'],
        queryFn: () => getData()
    });
};
